/** Catalogue index, ranked by relevance. */
export const CATALOGUE_INDEX = 'pocIndex';

/**
 * Standard replica of the catalogue index, sorted alphabetically. Serves the empty
 * search: with no terms to score, every record ties on the textual ranking criteria
 * and the order falls back to the objectID, which reads as random.
 */
export const CATALOGUE_INDEX_ALPHABETICAL = 'pocIndex_alphabetic_asc';
